/**
 * Web shim for react-native-webview
 * Renders an <iframe> on web.
 */

import React from 'react';
import { View } from 'react-native';

interface WebViewProps {
  source?: { html?: string; uri?: string };
  style?: any;
  scrollEnabled?: boolean;
  onMessage?: (event: any) => void;
  javaScriptEnabled?: boolean;
  domStorageEnabled?: boolean;
  allowsInlineMediaPlayback?: boolean;
  thirdPartyCookiesEnabled?: boolean;
  originWhitelist?: string[];
  onShouldStartLoadWithRequest?: (request: any) => boolean;
  children?: React.ReactNode;
}

const WebView: React.FC<WebViewProps> = ({
  source,
  style,
  scrollEnabled = true,
  onMessage,
}) => {
  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  if (source?.html) {
    return (
      <View style={style}>
        <iframe
          ref={iframeRef}
          srcDoc={source.html}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            overflow: scrollEnabled ? 'auto' : 'hidden',
          }}
          sandbox="allow-scripts allow-same-origin allow-popups"
        />
      </View>
    );
  }

  if (source?.uri) {
    return (
      <View style={style}>
        <iframe
          ref={iframeRef}
          src={source.uri}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            overflow: scrollEnabled ? 'auto' : 'hidden',
          }}
          sandbox="allow-scripts allow-same-origin allow-popups"
        />
      </View>
    );
  }

  return null;
};

export default WebView;
